import gql from "graphql-tag";
import { taskServiceTypeDef } from "../definitions/task-service-type-def";
import { errorsTypeDef } from "../../errors/errors-type-def";

const moreTasksQuery = gql`
  query moreTasks($cursor: String, $sortingDesc: Boolean) {
    task {
      moreTasks(input: {
        cursor: $cursor
        sortingDesc: $sortingDesc
      }) {
        cursor
        output {
          ${taskServiceTypeDef}
        }
        errors {
          ${errorsTypeDef}
        }
      }
    }
  }
`;

export default moreTasksQuery;
